import { ExclamationTriangleIcon } from "@heroicons/react/16/solid";

type TestIndicatorProps = {
  testMode: boolean;
};

const TestIndicator = ({ testMode }: TestIndicatorProps) => {
  if (!testMode) return null;

  return (
    <div className="h-8 absolute top-2 left-1/2 -translate-x-1/2 bg-[#ededed] opacity-70 p-[10px]">
      <div className="flex items-center size-full uppercase">
        <ExclamationTriangleIcon className="size-4" />
        &nbsp;Test Mode
      </div>
    </div>
  );
};

export default TestIndicator;
